import React from "react";
import clsx from "clsx";

import styles from "./ContainerBleed.module.css";

export default React.forwardRef(function ContainerBleed(
  { tag: Tag = "div", noMargin = false, className, color, ...rest },
  ref,
) {
  return (
    <Tag
      {...rest}
      ref={ref}
      className={clsx(styles.bleed, className, noMargin && styles.noMargin)}
    />
  );
});
